import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { backend } from '../config/configureBackend';
  import { onValue, update, set, child, remove, push } from "../config/supabaseDatabaseCompat";
  import { createRecordId, deleteAppFile, uploadAppFile } from '../data/appRecords';
  
  export const fetchCars = () => (dispatch) => {
  
    const {
        carsRef
    } = backend;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage
    } = backend;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        const id = car.id || createRecordId();
        push(child(carAddRef, id), { ...car, id });
    } else if (method === 'Delete') {
      await remove(carEditRef(car.id));
      await deleteAppFile('cars', car.id).catch(() => {});
    } else if (method === 'UpdateImage') {
      const image = await uploadAppFile('cars', car.id, car.car_image);
      let data = car;
      data.car_image = image;
      set(carEditRef(car.id), data);
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: image
        });
      }   
    }
     else {
        set(carEditRef(car.id),car);
    }
  }

  export const updateUserCarWithImage = (newData, blob) => async (dispatch) => {
    const {
      auth,
      singleUserRef,
      carAddRef
    } = backend;

    const carId = createRecordId();
    await set(child(carAddRef, carId), { ...newData, id: carId });
    const url = await uploadAppFile('cars', carId, blob);
      newData.car_image = url;
      await set(child(carAddRef, carId), { ...newData, id: carId });
      if(newData.active){
        let updateData = {
          carType: newData.carType,
          vehicleNumber: newData.vehicleNumber,
          vehicleMake: newData.vehicleMake,
          vehicleModel: newData.vehicleModel,
          other_info: newData.other_info,
          car_image:url,
          carApproved: newData.approved,
          updateAt: new Date().getTime()
        };
        update(singleUserRef(auth.currentUser.uid),updateData);
      }
  };